<div class="d-flex w-100">
  <div
    id="source-answers"
    class="dragula-container h-100 w-50"
    dragula="{{ question }}"
    [(dragulaModel)]="answerOptions"
  >
    <div class="option" *ngFor="let answer of answerOptions">
      <div *ngIf="!useImages">
        {{ answer }}
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <img
          class="img-fluid app-img-item shadow"
          [src]="getImagePath(answer)"
          *ngIf="useImages"
        />
      </div>
    </div>
  </div>
  <div
    id="target-answers"
    class="dragula-container h-100 w-50"
    dragula="{{ question }}"
    [(dragulaModel)]="answers"
  >
    <div class="option" *ngFor="let answer of answers">
      <div *ngIf="!useImages">
        {{ answer }}
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <img
          class="img-fluid app-img-item shadow"
          [src]="getImagePath(answer)"
          *ngIf="useImages"
        />
      </div>
    </div>
  </div>
</div>
